export const statementDefaultContent = {
    en: {
        statementText: {
            content: 'The present moment is our canvas in time. Here, we paint our stories and connect deeply. Cherish this fleeting gift.'
        },
    },
    es: {
        statementText: {
            content: 'El momento presente es nuestro lienzo en el tiempo. Aquí pintamos nuestras historias y nos conectamos profundamente. Aprecia este regalo fugaz.'
        }
    }
}
